import React, { PureComponent } from "react";

class AboutPage extends PureComponent {
  render() {
    return (
      <div>
        <h1>About</h1>

        <div
          style={{
            margin: 5
          }}
        >
          <p>Electric bass, upright bass, acoustic bass</p>

          <p>Vocals - lead and harmony</p>

          <p>Country, bluegrass, rock</p>

          <p>
            Toured all over the great country of the United States of America
          </p>

          <p>Home is the Twin Cities</p>
        </div>
      </div>
    );
  }
}

export default AboutPage;



// WEBPACK FOOTER //
// ./src/routes/about/AboutPage.js